export default __webpack_public_path__ + "static/media/doodle-up.d2bb7a9f.png";